(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref931"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref931"] = parcelRequire;
}
parcelRequire.register("lGKbD", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $fca158e7bc793dc7$export$6503ec6e8aabbaf; }, function (v) { return $fca158e7bc793dc7$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $fca158e7bc793dc7$export$f7ad0328861e2f03; }, function (v) { return $fca158e7bc793dc7$export$f7ad0328861e2f03 = v; });
var $fca158e7bc793dc7$export$6503ec6e8aabbaf;
var $fca158e7bc793dc7$export$f7ad0328861e2f03;
"use strict";
var $fca158e7bc793dc7$var$mapping = {};
function $fca158e7bc793dc7$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$fca158e7bc793dc7$var$mapping[keys[i]] = pairs[keys[i]];
}
function $fca158e7bc793dc7$var$resolve(id) {
    var resolved = $fca158e7bc793dc7$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$fca158e7bc793dc7$export$6503ec6e8aabbaf = $fca158e7bc793dc7$var$register;
$fca158e7bc793dc7$export$f7ad0328861e2f03 = $fca158e7bc793dc7$var$resolve;

});

var $5217f2c1c4be9920$exports = {};

(parcelRequire("lGKbD")).register(JSON.parse('{"7lIXA":"index.75c6927a.js","aJEB8":"about-us.f2f047ba.jpeg","k1FHE":"fetch.165263dc.js","awiG3":"index.0c344416.css"}'));

})();
//# sourceMappingURL=index.9c2d775b.js.map
